import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {FormsModule} from '@angular/forms';
import {ParametersModule} from '@catmodules/models/parameters/parameters.module';
import {ModifyUnitComponent} from '@catmodules/models/units/components/modify-unit/modify-unit.component';
import {UnitsService} from '@catmodules/models/units/services/units.service';
import {UIBaseModule} from '@catui/ui-base.module';
import {UIFormModule} from '@catuiform/ui-form.module';

const publicComponents = [
  ModifyUnitComponent,
];

const imports = [
  CommonModule,
  FormsModule,
  UIBaseModule,
  UIFormModule,
  ReactiveFormsModule,
  ParametersModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [UnitsService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class UnitsModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/units/units.module.ts